<template>
  <span
    :style="badgeStyles"
    :class="{ badge: true, relative: removable, 'pr-32': removable }"
    @click="badgeClick"
  >
    <i v-if="badgeSlot === 'start'" :class="icon"></i>
    {{ label }}
    <i v-if="badgeSlot === 'end'" :class="icon"></i>

    <div v-if="removable" class="removable-button">
      <s-button
        :round="true"
        :mini="true"
        icon="close.png"
        tool-tip="Remove"
        title="''"
        @clicked-item="onRemove"
        :icon-opacity="1"
      />
    </div>
  </span>
</template>

<script>
import SButton from "./SButton";

export default {
  name: "SBadge",
  components: {
    SButton,
  },
  props: {
    icon: { Type: String },
    badgeSlot: { Type: String },
    label: { type: String },
    color: { type: String, default: "#000000" },
    background: { type: String, default: "#ffffff" },
    border: { type: Boolean, default: false },
    borderColor: { type: String, default: "#000000" },
    padding: { type: String, default: "8px" },
    round: { type: Boolean, default: false },
    removable: { default: false },
  },

  methods: {
    onRemove() {
      this.$emit("remove", true);
    },
    badgeClick(){
      this.$emit("badge-click",this.label);
    },
  },

  computed: {
    badgeStyles() {
      var bgcolor, fcolor, bcolor, bradius;

      if (
        this.background.indexOf("#") === 0 ||
        this.background.indexOf("r") === 0
      ) {
        bgcolor = this.background;
      } else {
        bgcolor = "var(--" + this.background + ")";
      }
      if (this.color.indexOf("#") === 0 || this.color.indexOf("r") === 0) {
        fcolor = this.color;
      } else {
        fcolor = "var(--" + this.color + ")";
      }
      if (this.round) {
        bradius = "50%";
      } else {
        bradius = "16px";
      }
      if (
        this.borderColor.indexOf("#") === 0 ||
        this.borderColor.indexOf("r") === 0
      ) {
        bcolor = this.borderColor;
      } else {
        bcolor = "var(--" + this.borderColor + ")";
      }
      if (this.border) {
        return {
          border: this.border ? "solid 1px " : "",
          color: fcolor,
          "border-color": bcolor,
          "background-color": bgcolor,
          padding: this.padding,
          "border-radius": bradius,
        };
      }
      return {
        "background-color": bgcolor,
        border: this.border ? "solid 1px" : "",
        "border-color": bgcolor,
        color: fcolor,
        padding: this.padding,
        "border-radius": bradius,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
    font-family: "Roboto !important";
  font-size: 10px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  cursor: pointer;
}

.removable-button {
  position: absolute;
  top: -2px;
  right: 0;
}

.pr-32 {
  padding-right: 32px !important;
}
</style>